const data = {
  id: 1,
  title: 'Choose the correct form of the verb.',
  subTitle: 'Chọn dạng đúng của động từ.',
  question: 'They ___ to school yesterday',
  answers: [
    { id: 1, answer: 'go', isCorrect: false },
    { id: 2, answer: 'gone', isCorrect: false },
    { id: 3, answer: 'went', isCorrect: true },
  ],
};

export default data;
